var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "28px",
    viewBox: "0 0 43 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fillPattern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 43,
    height: 28
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fillPattern",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#5B5B5B",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 41,
    height: 26
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    id: "Path",
    stroke: "#5B5B5B",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35, 0)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 51,
    x2: 52,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 51,
    x2: 60,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 51,
    x2: 69,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 51,
    x2: 77,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 51,
    x2: 85,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49,
    y1: 51,
    x2: 93,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 51,
    x2: 101,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 51,
    x2: 44,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 51,
    x2: 117,
    y2: -9.89149157e-8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 51,
    x2: 109,
    y2: -9.89149157e-8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillPattern);
export default __webpack_public_path__ + "static/media/fillPattern.b864793ceaf3f1df3514612c08ccf637.svg";
export { ForwardRef as ReactComponent };